// All code inside <Authentication></Authentication> will need to be authenticated.
// That means user need to be logged in to access the content.

import { useEffect, useState } from 'react';
import useAuthentication from 'src/hooks/useAuthentication';
import KeycloakAuth from 'src/Components/Auth/KeycloakAuth';
import USER_TOKEN from 'src/graphql/queries/authQuery';
import { useQuery } from '@apollo/client';

type Props = {
    children?: React.ReactNode;
};

const Authentication = (props: Props) => {
    const { children } = props;

    const [shouldStartKeycloak, setShouldStartKeycloak] = useState(false);
    const [keycloakError, setKeycloakError] = useState<Error | null>(null);
    const [shouldStartAuth0, setShouldStartAuth0] = useState(false);

    const { data: userToken } = useQuery(USER_TOKEN);

    // Auth0 Auth
    const { error: auth0Error } = useAuthentication(shouldStartAuth0);

    useEffect(() => {
        // 1. Start Keycloak Auth
        // This will do following
        // - Mount SSO v2 Iframe, it will initialise Keycloak token
        // - If authenticated create interval to refresh token
        // - Otherwise set keycloak error which will trigger effect below
        setShouldStartKeycloak(true);
    }, []);

    useEffect(() => {
        if (keycloakError) {
            // 2. Stop Keycloak auth
            // 3. Start Auth0 Auth
            setShouldStartKeycloak(false);
            setShouldStartAuth0(true);
        }
    }, [keycloakError]);

    if (keycloakError && auth0Error) {
        return <p>Failed to authenticate</p>;
    }

    return (
        <>
            <KeycloakAuth shouldStart={shouldStartKeycloak} setError={setKeycloakError} />
            {!!userToken.token && children}
        </>
    );
};

export default Authentication;
